import { SyntheticEvent } from 'react';

import { Icon, useTheme } from '@desygner/ui-common-components';

import { StyledCloseButton } from './CloseButton.style';

export type CloseIconButtonProps = {
  onClick: (event: SyntheticEvent<HTMLElement>) => void;
  type?: 'floating' | 'default';
};

export function CloseButton({ onClick, type = 'default' }: CloseIconButtonProps) {
  const theme = useTheme();

  return (
    <StyledCloseButton onClick={onClick} type={type}>
      <Icon name="cross" color={theme.Color.Neutrals.Dark} />
    </StyledCloseButton>
  );
}
